import { app } from './main-app'
import router from '@/routers'

app.use(router)
